<template>
  <div
    v-if="isDisconnected"
    class="platform-disconnect-banner"
    data-testid="platform-disconnect-banner"
    role="alert"
  >
    {{ t('platform.platformDisconnectedBanner') }}
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/common/composables/useI18n'
import { storeToRefs } from 'pinia'
import { usePlatformConnectionStore } from '@/stores/platformConnection'

const { t } = useI18n()
const { isDisconnected } = storeToRefs(usePlatformConnectionStore())
</script>

<style scoped lang="scss">
.platform-disconnect-banner {
  flex: 0 0 auto;
  padding: 0.65rem 1rem;
  background: #fff3cd;
  color: #664d03;
  border-bottom: 1px solid #ffecb5;
  font-size: 0.9rem;
  line-height: 1.35;
}
</style>
